var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ApiService from "@/ts/core/services/ApiService";
import Swal from "sweetalert2";
import { startSpinner } from "../modules/startSpinner";
document.addEventListener("DOMContentLoaded", function () {
    var Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: function (toast) {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
    // 문의 종류 선택
    var options = document.querySelectorAll(".option");
    options.forEach(function (option) {
        option.addEventListener("click", function () {
            options.forEach(function (opt) { return opt.classList.remove("select"); });
            option.classList.add("select");
        });
    });
    // 이메일로 문의 전송
    var submitBtn = document.querySelector(".submit_btn");
    if (submitBtn) {
        submitBtn.addEventListener("click", function () { return __awaiter(void 0, void 0, void 0, function () {
            var typeValue, categoryElement, contentElement, mobileElement, categoryValue, contentValue, mobileValue, referUrl, data, _a, spinnerContainer, spinner;
            var _b;
            return __generator(this, function (_c) {
                typeValue = ((_b = document.querySelector(".type_input")) === null || _b === void 0 ? void 0 : _b.value) || "";
                categoryElement = document.querySelector(".option.select");
                contentElement = document.querySelector(".contents_text");
                mobileElement = document.querySelector(".mobile_text");
                categoryValue = categoryElement ? categoryElement.value : "";
                contentValue = contentElement ? contentElement.value : "";
                mobileValue = mobileElement ? mobileElement.value : "";
                referUrl = localStorage.getItem('refer_url') || '';
                data = new FormData();
                data.append("type", typeValue);
                data.append("category", categoryValue);
                data.append("content", contentValue);
                data.append("mobile", mobileValue);
                data.append("refer_url", referUrl);
                _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
                ApiService.post("".concat(process.env.MIX_API_HOST, "/mail/contact/"), data)
                    .then(function (_a) {
                    var data = _a.data;
                    console.log(data);
                    if (options.length > 0) {
                        options.forEach(function (opt) { return opt.classList.remove("select"); });
                        options[0].classList.add("select");
                    }
                    if (contentElement)
                        contentElement.value = "";
                    localStorage.removeItem('refer_url');
                    window.showModal("defalutbtnModal");
                })
                    .catch(function (_a) {
                    var response = _a.response;
                    console.log(response.data.message);
                    Toast.fire({
                        text: response.data.message,
                        icon: "error",
                    });
                })
                    .finally(function () {
                    if (spinnerContainer) {
                        spinnerContainer.style.display = 'none';
                    }
                    spinner.stop();
                });
                return [2 /*return*/];
            });
        }); });
    }
});
